export default "__VITE_ASSET__D9JcL4R4__"